export default __webpack_public_path__ + "service-worker-dddfe83.js";